module.exports = __webpack_public_path__ + "images/emoji/rose.fea3575bd85440111231.png";